module.exports = __webpack_public_path__ + "img/solution-domainHIL-components.25b94a54.png";